// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2WQCu","footer":"ReportModalFilter_footer__1LP93"};